// THT-758 — the 25% beneficial-ownership floor for the signup Personal Info step.
//
// Sila only registers a driver as a beneficial owner when they hold at least 25%
// of the business (see `registerOwnerHelper` in
// tach-architecture/temporal/src/workflows/newCustomerWorkflows/beginSilaVerificationWorkflowHandler.ts).
// A 10% owner used to sail through the form and fail verification days later, so
// the floor is enforced at the field. Bounds and copy live here — shared by the
// component and its tests — so the rule is stated in exactly one place.

/** Minimum ownership a primary owner may declare and still continue signup. */
export const MIN_OWNERSHIP_PERCENTAGE = 25;

/** Nobody can own more than the whole business. */
export const MAX_OWNERSHIP_PERCENTAGE = 100;

/**
 * Validation copy for the ownership-percentage field. `belowMinimum` names the
 * 25% rule outright — the customer needs to know why they are blocked, not just
 * that they are.
 */
export const OWNERSHIP_PERCENTAGE_MESSAGES = {
  required: 'Ownership percentage is required',
  invalid: 'Please enter a valid number',
  belowMinimum: `You must own at least ${MIN_OWNERSHIP_PERCENTAGE}% of the business to continue.`,
  aboveMaximum: `Ownership cannot exceed ${MAX_OWNERSHIP_PERCENTAGE}%.`,
};
